import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; 
import './answercontrol.css';

export default function AssignAssigments() {
  const [config, setConfig] = useState(null);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalMarks, setTotalMarks] = useState("");
  const [assignedTable, setAssignedTable] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");


  
  const navigate = useNavigate();

  // Load config
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error(err));
  }, []);

  // Fetch batches
  useEffect(() => {
    if (!config) return;
    const fetchBatches = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.GET_BATCHES}`);
        const data = await res.json();
        if (data.success) setBatches(data.batches);
      } catch (err) {
        console.error(err);
      }
    };
    fetchBatches();
  }, [config]);

  // Fetch slots when batch changes
  useEffect(() => {
  if (!selectedBatch || !config) return;

  const batchName = batches.find(
    b => String(b.batch_id) === String(selectedBatch)
  )?.batch_name;

  if (!batchName) return;

  const fetchSlots = async () => {
    try {
      const res = await fetch(
        `${config.BASE_URL}${config.FETCH_SLOTS_BY_BATCH}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            batch_name: batchName,
          }),
        }
      );

      const data = await res.json();
      if (data.success) {
        setSlots(data.slots);
      } else {
        setSlots([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  fetchSlots();
}, [selectedBatch, batches, config]);


  // Fetch questions after selecting slot
  useEffect(() => {
    if (!selectedSlot || !selectedBatch || !config) return;

    const batchName = batches.find(b => b.batch_id === selectedBatch)?.batch_name;
    const slot = slots.find(s => s.slot_no === selectedSlot);
    if (!batchName || !slot) return;

    const fetchQuestions = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.FETCH_ASSIGNMENTS}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
             batch_name: batchName,
            slot_no: slot.slot_no,
            domain: slot.domain
           })
        });

        const data = await res.json();
        if (data.success) {
          setQuestions(data.assignments || []);
          setSelectedQuestion("");
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchQuestions();
  }, [selectedSlot, selectedBatch, batches, slots, config]);

  const handleProceed = async () => {
  if (!selectedBatch || !selectedSlot || !selectedQuestion || !startDate || !endDate || !totalMarks) {
    alert("Please fill all fields before proceeding");
    return;
  }

  try {
    const res = await fetch(`${config.BASE_URL}${config.ASSIGN_ASSIGNMENTS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        batch_id: selectedBatch,
        slot_no: selectedSlot,
        domain: slots.find(s => s.slot_no === selectedSlot).domain,
        question_id: selectedQuestion,
        start_date: startDate,
        end_date: endDate,
        total_marks: totalMarks
      })
    });

    const data = await res.json();
    if (data.success) {
      alert(data.message);
      setSelectedBatch(""); 
      setSelectedSlot(""); 
      setSelectedQuestion(""); 
      setStartDate(""); 
      setEndDate(""); 
      setTotalMarks("");
      setSlots([]);
      setQuestions([]);
    } else {
      alert(data.message);
    }

  } catch (err) {
    console.error(err);
    alert("Failed to assign the assignment.");
  }
};


useEffect(() => {
  if (!config) return;

  const fetchAssigned = async () => {
    try {
      const res = await fetch(`${config.BASE_URL}${config.FETCH_ASSIGNED_LIST}`, {
        method: "POST", 
        headers: { "Content-Type": "application/json" },
      });
      const data = await res.json();
      if (data.success) setAssignedTable(data.assigned || []);
    } catch (err) {
      console.error(err);
    }
  };

  fetchAssigned();
}, [config]);



  return (
    <>
    <div className="batch-slot-selector">
      <h2>Assign Assignments</h2>

      <div className="dropdown-group">
        <label>Batch:</label>
        <select value={selectedBatch} onChange={e => { setSelectedBatch(e.target.value); setSelectedSlot(""); }}>
          <option value="">Select Batch</option>
          {batches.map(b => (
            <option key={b.batch_id} value={b.batch_id}>{b.batch_name}</option>
          ))}
        </select>
      </div>

      {slots.length > 0 && (
        <div className="dropdown-group">
          <label>Slot:</label>
          <select value={selectedSlot} onChange={e => setSelectedSlot(e.target.value)}>
            <option value="">Select Slot</option>
            {slots.map(s => (
              <option key={s.slot_no} value={s.slot_no}>{s.slot_no}-{s.domain}-{s.mode}</option>
            ))}
          </select>
        </div>
      )}

      {questions.length > 0 && (
        <div className="dropdown-group">
          <label>Question:</label>
          <select value={selectedQuestion} onChange={e => setSelectedQuestion(e.target.value)}>
            <option value="">Select Question</option>
            {questions.map(q => (
              <option key={q.assignment_id} value={q.assignment_id}>{q.question_name}</option>
            ))}
          </select>
        </div>
      )}

      {/* Start & End Date */}
      {selectedQuestion && (
        <>
          <div className="dropdown-group">
            <label>Start Date:</label>
            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
          </div>

          <div className="dropdown-group">
            <label>End Date:</label>
            <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
          </div>

          <div className="dropdown-group">
            <label>Total Marks:</label>
            <input type="number" value={totalMarks} onChange={e => setTotalMarks(e.target.value)} placeholder="Enter total marks" />
          </div>
        </>
      )}

      <button onClick={handleProceed} className="ans-submit-btn">
        Proceed
      </button>
    </div>

  <div className="assigned-table-container">
  <h3 style={{ marginBottom: "20px" }}>Questions list</h3>

  {/* Search Input */}
  <div style={{ marginBottom: "10px" }}>
    <input
      type="text"
      placeholder="Search by batch, slot, domain, or question"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      style={{ padding: "5px", width: "300px" }}
    />
  </div>

  <table className="assigned-table">
    <thead>
      <tr>
        <th>Batch</th>
        <th>Slot</th>
        <th>Domain</th>
        <th>Question</th>
        <th>Status</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Total Marks</th>
      </tr>
    </thead>
    <tbody>
      {assignedTable
        .filter((item) => {
          const query = searchQuery.toLowerCase();
          return (
            (item.batch_name || "").toLowerCase().includes(query) ||
            (item.slot_no || "").toLowerCase().includes(query) ||
            (item.domain || "").toLowerCase().includes(query) ||
            (item.question_name || "").toLowerCase().includes(query)
          );
        })
        .map((item, idx) => {
          const isAssigned = item.start_date && item.end_date;
          return (
            <tr key={idx} className={isAssigned ? "assigned" : "unassigned"}>
              <td>{item.batch_name || "-"}</td>
              <td>{item.slot_no || "-"}</td>
              <td>{item.domain || "-"}</td>
              <td>{item.question_name}</td>
              <td>{isAssigned ? "Assigned" : "Not Assigned"}</td>
              <td>{item.start_date || "-"}</td>
              <td>{item.end_date || "-"}</td>
              <td>{item.total_marks || "-"}</td>
            </tr>
          );
        })}
    </tbody>
  </table>
</div>



</>
    
  );
}
